import { render, staticRenderFns } from "./ShowDetailsWrapper.vue?vue&type=template&id=657506bd&"
import script from "./ShowDetailsWrapper.vue?vue&type=script&lang=js&"
export * from "./ShowDetailsWrapper.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports